import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Đảm bảo CSS của DatePicker hoạt động

function HistoryCasino() {
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [history, setHistory] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(new Date());
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    function formatDate(m) {
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}${month}${day}`;
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/historymember`, { date: formattedDate })
            .then((res) => {
                setHistory(res.data.data);
            })
            .catch((err) => function () {});
            
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    const selectHistory = (date) => {
        if (isLoading === true) return;
        setLoading(true);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}${month}${day}`;
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/historymember`, { date: formattedDate })
            .then((res) => {
                setHistory(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };

    const productId = (data) => {
        let a;
        switch (data.toString()) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "99": a = "TF"; break;
            case "111": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            default: a = ""; break;
        }
        return a;
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .history-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER (BANNER CHUNG)                   */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. BỘ LỌC NGÀY VÀ DANH SÁCH THẺ                    */
                /* ================================================== */
                .history-content {
                    padding: 0 15px;
                }
                
                .date-picker-wrapper {
                    margin-bottom: 15px;
                    text-align: right;
                }
                .date-picker-wrapper input {
                    padding: 8px 15px;
                    border-radius: 20px;
                    border: 1px solid #ccc;
                    outline: none;
                    font-size: 14px;
                    color: #333;
                    text-align: center;
                    width: 130px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }

                .history-card {
                    background: #fff;
                    border-radius: 8px;
                    padding: 15px;
                    margin-bottom: 12px;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
                    cursor: pointer;
                    position: relative;
                }
                .history-card:active {
                    background: #fafafa;
                }
                .h-top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                    border-bottom: 1px solid #f0f0f0;
                    padding-bottom: 8px;
                }
                .h-type {
                    font-weight: bold;
                    font-size: 15px;
                    color: #333;
                }
                .h-status {
                    font-size: 12px;
                    font-weight: bold;
                    padding: 4px 8px;
                    border-radius: 4px;
                    background: #ff9800; /* Màu cam mặc định cho sảnh */
                    color: #fff;
                }

                .h-mid {
                    font-size: 12px;
                    color: #777;
                    margin-bottom: 8px;
                    line-height: 1.5;
                }

                .h-bot {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                }
                .h-money-bet {
                    font-size: 14px;
                    font-weight: bold;
                    color: #333; 
                }
                .h-money-win {
                    font-size: 14px;
                    font-weight: bold;
                    color: #4caf50; /* Màu xanh lá cho tiền thắng */
                }
                
                .empty-history {
                    text-align: center;
                    color: #888;
                    margin-top: 50px;
                    font-size: 14px;
                }

                /* ================================================== */
                /* 4. MODAL CHI TIẾT CƯỢC                             */
                /* ================================================== */
                .custom-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6);
                    z-index: 9999999;
                    display: flex; align-items: center; justify-content: center;
                }
                .custom-modal-content {
                    background: #fff;
                    width: 90%;
                    max-width: 400px;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.3);
                    animation: slideUp 0.3s ease-out;
                }
                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .custom-modal-header {
                    background: #b71c1c;
                    color: #fff;
                    padding: 15px;
                    font-size: 16px;
                    font-weight: bold;
                    text-align: center;
                    text-transform: uppercase;
                }
                .custom-modal-body {
                    padding: 15px 20px;
                }
                .custom-modal-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 10px 0;
                    border-bottom: 1px dashed #eee;
                    font-size: 14px;
                }
                .custom-modal-row:last-child { border-bottom: none; }
                .custom-modal-row span:first-child { color: #666; }
                .custom-modal-row span:last-child { font-weight: bold; color: #333; text-align: right; max-width: 60%; word-wrap: break-word; }
                .custom-modal-footer {
                    padding: 15px 20px 20px 20px;
                }
                .btn-close-modal {
                    background: #555;
                    color: #fff;
                    border: none;
                    padding: 12px;
                    border-radius: 6px;
                    font-weight: bold;
                    cursor: pointer;
                    width: 100%;
                    font-size: 15px;
                }
            `}</style>

            <div className="history-wrapper">

                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                    <h1 className="page-title-h1">Lịch sử game</h1>
                </div>

                {/* 3. NỘI DUNG LỊCH SỬ & CHỌN NGÀY */}
                <div className="history-content">
                    <div className="date-picker-wrapper">
                        <DatePicker
                            maxDate={new Date()}
                            selected={endDate}
                            onChange={(date) => {
                                setEndDate(date);
                                selectHistory(date);
                            }}
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>

                    {history && history.length > 0 ? (
                        history.map((item, index) => (
                            <div 
                                className="history-card" 
                                key={index}
                                onClick={() => {
                                    setLs(item);
                                    setShow(true);
                                }}
                            >
                                <div className="h-top">
                                    <div className="h-type">{item?.gameName}</div>
                                    <div className="h-status">
                                        {productId(item?.productType)}
                                    </div>
                                </div>
                                
                                <div className="h-mid">
                                    Thời gian: {formatDate(new Date(item?.betTime))}
                                </div>
                                
                                <div className="h-bot">
                                    <div className="h-money-bet">
                                        Cược: {Math.floor((item?.betAmount || 0) / 1000).toLocaleString("vi-VN")} Điểm
                                    </div>
                                    <div className="h-money-win">
                                        Thắng: {Math.floor((item?.winAmount || 0) / 1000).toLocaleString("vi-VN")} Điểm
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="empty-history">
                            Chưa có dữ liệu lịch sử game trong ngày này.
                        </div>
                    )}
                </div>
            </div>

       
            <Footer profile={profile} />

            {/* 4. MODAL CHI TIẾT CƯỢC (Tự động thêm vào cho đẹp) */}
            {isShow && ls && (
                <div className="custom-modal-overlay" onClick={() => setShow(false)}>
                    <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="custom-modal-header">
                            Chi tiết game
                        </div>
                        <div className="custom-modal-body">
                            <div className="custom-modal-row">
                                <span>Trò chơi</span>
                                <span>{ls?.gameName}</span>
                            </div>
                            <div className="custom-modal-row">
                                <span>Sảnh (Nhà cung cấp)</span>
                                <span>{productId(ls?.productType)}</span>
                            </div>
                            <div className="custom-modal-row">
                                <span>Thời gian</span>
                                <span>{formatDate(new Date(ls?.betTime))}</span>
                            </div>
                            <div className="custom-modal-row">
                                <span>Tổng Cược</span>
                                <span style={{ color: "#333" }}>{Math.floor((ls?.betAmount || 0) / 1000).toLocaleString("vi-VN")} Điểm</span>
                            </div>
                            <div className="custom-modal-row">
                                <span>Tổng thắng</span>
                                <span style={{ color: "#4caf50" }}>{Math.floor((ls?.winAmount || 0) / 1000).toLocaleString("vi-VN")} Điểm</span>
                            </div>
                        </div>
                        <div className="custom-modal-footer">
                            <button className="btn-close-modal" onClick={() => setShow(false)}>
                                ĐÓNG
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </AnimatedPage>
    );
}

export default HistoryCasino;